import ConditionsEditor from '@/common/components/ConditionsEditor/ConditionsEditor'

import { errorTypes } from '../constants'
import { getConditionTypes } from './helpers'

const AvailabilityCriterionConditionsEditor = ({
  conditions,
  onChange,
  disabled,
  productTypes,
  productCategories,
  productCollections,
  errors = [],
  currencies,
  storeCurrencyCode,
}) => {
  const conditionTypes = getConditionTypes({
    productTypes,
    productCategories,
    productCollections,
  })

  return (
    <ConditionsEditor
      conditions={conditions}
      onChange={onChange}
      disabled={disabled}
      errors={errors}
      title="Condiciones"
      description="Define el conjunto de condiciones que definen los criterios de disponibilidad"
      emptyMessage="Se requiere al menos una condición para que el criterio tenga efecto."
      conditionTypes={conditionTypes}
      errorType={errorTypes.conditionIncomplete}
      currencies={currencies}
      storeCurrencyCode={storeCurrencyCode}
    />
  )
}

export default AvailabilityCriterionConditionsEditor
